import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { CheckIcon } from 'lucide-react';
import { Typography } from '@/components/novoville';
import { translate } from '@/services/TranslationService';

import AuthPageContainer from '../auth/AuthPageContainter';
import { setLanguage } from '@/shared/actions';
import { getLanguage } from '@/services/GRNLwithoutDep';
import { useDispatch } from 'react-redux';
import { setDeeplinkData } from '../route/actions';

const PublicPaymentSuccess = () => {

  const dispatch = useDispatch();

  const initialLanguage = getLanguage();

  const [selectedLanguage, setSelectedLanguage] = useState(
    initialLanguage || ''
  );

  const handleLanguageChange = async (newLanguage) => {
    setSelectedLanguage(newLanguage);
    await dispatch(setLanguage(newLanguage));
  };

  useEffect(() => {
    dispatch(setDeeplinkData({
      code: null,
      needsDeeplinkRedirection: false,
    }));

    const timer = setTimeout(() => {
      window.location.href = '/public/payment/access';
    }, 7000);

    return () => clearTimeout(timer);
  }, [dispatch]);

  return (
    <AuthPageContainer
      language={selectedLanguage}
      handleLanguageChange={handleLanguageChange}
    >


      <div className="flex flex-1 sm:flex-grow-0 flex-col items-center justify-center bg-white relative py-16 px-6">
        <div className="flex flex-col items-center text-center gap-3">
          <div className="h-20 w-20 rounded-full bg-emerald-50 flex items-center justify-center">
            <CheckIcon className="h-10 w-10 text-emerald-500" />
          </div>
          <Typography variant="bold_20" className="text-gray-800">
            {translate('payment_successful') || 'payment successful!'}
          </Typography>
          <Typography variant="regular_16" className="text-gray-600 max-w-xl">
            {translate('payment_completed_subtitle') ||
              'Your transaction was completed successfully.'}
          </Typography>
        </div>
      </div>
    </AuthPageContainer>
  );
};

export default (withRouter(PublicPaymentSuccess));
